const secureArithmetic = (transformedNumber) => {
  try {
    const constantAdd = 22374;
    const constantMultiply = 57;
    const constantXOR = 546348970;

    // IMPORTANT: Use the same secondaryAdd that was originally added during encryption
    const secondaryAdd = 29454; // assume it's the last 5 digits
    const transformed = parseInt(transformedNumber, 10);

    if (isNaN(transformed)) {
      throw new Error("Invalid transformed number.");
    }

    const reverseStep3 = transformed - secondaryAdd;
    const reverseStep2 = reverseStep3 ^ constantXOR;
    const reverseStep1 = reverseStep2 / constantMultiply;
    const originalNumber = reverseStep1 - constantAdd;

    return Math.round(originalNumber);
  } catch (error) {
    console.error("Error recovering original number:", error);
    return null;
  }
};



export default secureArithmetic;
